module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#edit",
      toString: function () {
        return this.url;
      }
    }